import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { useGetUserCompanies } from "../../backend/query";
import { useHistory } from "raviger";
import { sortBy, debounce } from "underscore";
import { getUserDetails } from "../../backend/auth";
import DatePicker from "react-datepicker";
import { ActivityType } from "../pages/Masters/Master.constants";
import { ACTIVITY_TYPE, DEBOUNCE_TIME } from "../../utils/constants";
import dayjs from "dayjs";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { getActivities, getActs, getRules } from "../../backend/masters";
import { DEFAULT_OPTIONS_PAYLOAD } from "./Table";
import { activityOptionLabel, ruleOptionLabel } from "../pages/Masters/Mappings/MappingDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSearch } from "@fortawesome/free-solid-svg-icons";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "./FormRenderer";

function AuditLocationFilters({ onChange }: any) {
    const { state }: any = useHistory();
    const [newDueDate, setNewDueDate] = useState<any>();
    const [activityType, setActivityType] = useState<any[]>([]);
    const [auditType, setAuditType] = useState<any[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [moreFilters, setMoreFilters] = useState<any>({ hideButtons: true });
    const [appliedMoreFilters, setAppliedMoreFilters] = useState<any>({ hideButtons: true });
    const [acts, setActs] = useState<any[]>([]);
    const [rules, setRules] = useState<any[]>([]);
    const [activities, setActivities] = useState<any[]>([]);

    function actOptionLabel({ label, act = {} }: any) {
        return (
            <div className="d-flex flex-column">
                <div>{label} - <span className="fw-bold ms-1">{act.establishment_type}</span></div>
            </div>
        )
    }

    function onDueDateChange(date: any) {
      console.log('New Due Date:', date);
      setNewDueDate(date);
    }

    function onActivityTypeChange(selectedOptions: any) {
      console.log('Selected Activity Types:', selectedOptions);
      setActivityType(selectedOptions || []);
    }

    function onAuditTypeChange(selectedOptions: any) {
      console.log('Selected Audit Types:', selectedOptions);
      setAuditType(selectedOptions || []);
    }

    useEffect(() => {
      onLocationChange();
    }, [newDueDate, activityType, auditType]);

    function onLocationChange(clearMoreFilters: boolean = false) {
      let _filter: any = {};
      if(newDueDate){
        _filter.due_date_lteq = dayjs(newDueDate).endOf('D').local().format();
      }
      if (activityType && activityType.length > 0) {
        _filter.activity_activity_type_in = activityType.map((x: any) => x.value);
      }
      if (auditType) {
          _filter.auditted_in = auditType.map((x: any) => x.value);
      }
      if(!clearMoreFilters){
        if(moreFilters.act) {
          _filter.act_id_eq = moreFilters.act.value;
        }
        if(moreFilters.rule) {
          _filter.rule_id_eq = moreFilters.rule.value;
        }
        if(moreFilters.activity) {
          _filter.activity_id_eq = moreFilters.activity.value;
        }
      }
      onChange(_filter);
    }

    const schema: any = {
        fields: [
            {
                component: componentTypes.ASYNC_SELECT,
                name: 'act',
                label: 'Act',
                defaultOptions: acts,
                formatOptionLabel: actOptionLabel,
                loadOptions: debounce((keyword: any, callback: any) => {
                    getActs({ ...DEFAULT_OPTIONS_PAYLOAD, filters: {name_cont: keyword} }).then(response => {
                        const list = ((response || {}).data || {}).items || [];
                        const _options = list.map((act: any) => {
                            return { value: act.id, label: act.name, act }
                        });
                        setActs(_options);
                        callback(_options);
                    })
                }, DEBOUNCE_TIME),
                isClearable: true
            },
            {
                component: componentTypes.ASYNC_SELECT,
                name: 'rule',
                label: 'Rule',
                defaultOptions: rules,
                formatOptionLabel: ruleOptionLabel,
                loadOptions: debounce((keyword: any, callback: any) => {
                    getRules({ ...DEFAULT_OPTIONS_PAYLOAD, page: 1, per: 100, filters: {name_or_unique_identifier_cont: keyword} }).then(response => {
                        const list = ((response || {}).data || {}).items || [];
                        const _options = list.map((rule: any) => {
                            return { value: rule.id, label: rule.name, rule }
                        });
                        setRules(_options);
                        callback(_options);
                    })
                }, DEBOUNCE_TIME),
                isClearable: true
            },
            {
                component: componentTypes.ASYNC_SELECT,
                name: 'activity',
                label: 'Activity',
                formatOptionLabel: activityOptionLabel,
                defaultOptions: activities,
                loadOptions: debounce((keyword: any, callback: any) => {
                    getActivities({ ...DEFAULT_OPTIONS_PAYLOAD, filters: {name_cont: keyword} }).then(response => {
                        const list = ((response || {}).data || {}).items || [];
                        const _options = list.map((activity: any) => {
                            return { value: activity.id, label: activity.name, activity }
                        });
                        setActivities(_options);
                        callback(_options);
                    })
                }, DEBOUNCE_TIME),
                isClearable: true
            }
        ]
    };

    function debugForm(_form: any) {
        setMoreFilters(_form.values);
    }

    function handleOpenModal() {
        // Copy applied filters to working state when opening modal
        setMoreFilters({ ...appliedMoreFilters });
        setShowModal(true);
    }

    function handleCloseModal() {
        // Discard changes when clicking Back
        setMoreFilters({ ...appliedMoreFilters });
        setShowModal(false);
    }

    function handleApplyMoreFilters() {
        // Save working state to applied state
        setAppliedMoreFilters({ ...moreFilters });
        setShowModal(false);
        // Apply filters with the new values
        setTimeout(() => {
            onLocationChange();
        }, 0);
    }

    function handleClearMoreFilters() {
        setMoreFilters({ hideButtons: true });
        setAppliedMoreFilters({ hideButtons: true });
        setShowModal(false);
        onLocationChange(true);
    }

    function getMoreFiltersCount() {
        let count = 0;
        if (appliedMoreFilters.act) count++;
        if (appliedMoreFilters.rule) count++;
        if (appliedMoreFilters.activity) count++;
        return count;
    }

    return (
        <>
            <div className="al-filter-group">
                <label>Due Date</label>
                <DatePicker
                  className="al-native-select"
                  selected={newDueDate}
                  dateFormat="dd-MM-yyyy"
                  onChange={onDueDateChange}
                  placeholderText="dd-mm-yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  isClearable
                />
            </div>
            <div className="al-filter-group">
                <label>Activity Type</label>
                <Select placeholder='Activity Type' options={ActivityType.map((x: any) => {return {label: x, value: x}})} onChange={onActivityTypeChange} value={activityType} className="al-rs" classNamePrefix="al-rs" isMulti={true} menuPortalTarget={document.body} menuPosition="fixed" styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} />
            </div>
            <div className="al-filter-group">
                <label>Audit Type</label>
                <Select placeholder='Audit Type' options={Object.values(ACTIVITY_TYPE).map((x: any) => {return {label: x, value: x}})} onChange={onAuditTypeChange} value={auditType} className="al-rs" classNamePrefix="al-rs" isMulti={true} menuPortalTarget={document.body} menuPosition="fixed" styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} />
            </div>
        </>
    )
}

export default AuditLocationFilters;
